(function () {
  'use strict';

  var closeSequence = 0;

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var closeButton = target.closest('[role="button"][aria-label="Close chat"]');
    var inChat = target.closest('[role="dialog"][aria-label="Chat window"]');
    var closingWithEscape = event.key === 'Escape' && (inChat || closeButton);
    var closingWithButton = closeButton && (event.key === 'Enter' || event.key === ' ');
    if (!closingWithEscape && !closingWithButton) return;

    var sequence = ++closeSequence;
    [250, 500, 1000].forEach(function (delay) {
      window.setTimeout(function () {
        if (sequence !== closeSequence) return;
        var launcher = document.querySelector('[role="button"][aria-label="Open chat"]') ||
          document.querySelector('[role="button"][aria-label="Close chat"]');
        if (!launcher || !launcher.getClientRects().length) return;

        var active = document.activeElement;
        if (active === document.body || active === document.documentElement || active === launcher) {
          launcher.focus({ preventScroll: true });
          closeSequence++;
        } else if (!active.closest('[role="dialog"][aria-label="Chat window"]')) {
          closeSequence++;
        }
      }, delay);
    });
  }, true);
}());
